"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Styled = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@material-ui/core");
var _theme = require("../theme");
var _templateObject;
var spacing = _theme.theme.spacing,
  palette = _theme.theme.palette;
var Styled = (0, _styledComponents["default"])(_core.FormControl)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n&.select {\n  min-width: 150px;\n  margin-bottom: 16px;\n .form-group {\n   position: relative;\n }\n\n label {\n   transform: translate(16px, 24px) scale(1);\n   color: ", ";\n\n   z-index: 1;\n   &[data-shrink=\"true\"] {\n     transform: translate(16px, 10px) scale(0.75);\n   }\n }\n\n .helper-text {\n   margin: ", ";\n   ", "\n }\n\n button {\n   padding: 10px 16px;\n   min-height: 24px;\n   line-height: 1.5em;\n   flex: 1;\n   height: 100%;\n   justify-content: left;\n   text-align: left;\n   width: 100%;\n   cursor: pointer;\n   color: black;\n   font-size: 1rem;\n   font-weight: 400;\n   font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n   hover: {\n     background-color: rgba(0, 0, 0, 0.14);\n   }\n }\n"])), function (props) {
  var disabled = props.disabled,
    error = props.error,
    originalvalue = props.originalvalue;
  var color = '#002B39';
  if (error) color = palette.error.main;
  if (disabled && !originalvalue) color = '#888888';
  return color;
}, "".concat(spacing() / 4, "px ").concat(spacing(2), "px"), function (props) {
  return props.error ? "color: ".concat(palette.error.main, ";") : 'color: #666666;';
});
exports.Styled = Styled;